import axios from "axios";
import { ElMessage } from 'element-plus';

import QS from "qs";
import {
  getToken,
  encodex
} from "@/utils/auth";
import { validEmpty, isArray } from "@/utils/validate";
import {
  client_id,
  client_secret
} from "@/utils/config";
import store from '@/store';
axios.defaults.headers.common.Accept = "application/json,text/plain,*/*";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["X-CSRFToken"] = getToken();
axios.defaults.headers["content-type"] = "application/x-www-form-urlencoded";
// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded;charset=UTF-8";
// create an axios instance
const service = axios.create({
  baseURL: "https://ipyxis.pyxis-cloud.com", // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000, // request timeout
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    config.params = config.params || {};
    // do something before request is sent
    if (config.url.indexOf("o/token") > -1) {
      // config.baseURL = loginApiDomainUrl;
      config.headers["Authorization"] = "Basic " + encodex(client_id + ":" + client_secret);
    } else {
      if (config.url.indexOf("logout_erp") == -1) {
        config.url = "/api/" + config.url;
      }
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    if (config.method.toUpperCase() === "GET") {
      for (let key in config.data) {
        config.params[key] = config.data[key];
      }
    }
    if (config["Content-Type"] && config["Content-Type"] === "form-data") {
      config.headers["Content-Type"] = "multipart/form-data";
      let fd = new FormData();
      for (let key in config.data) {
        if (isArray(config.data[key]) && config.data[key][0] instanceof File) {
          for (let index = 0; index < config.data[key].length; index++) {
            fd.append(key + "[" + index + "]", config.data[key][index]);;
          }
        } else {
          fd.append(key, config.data[key]);
        }
      }
      config.data = fd;
    } else {
      config.data = QS.stringify(config.data);
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    if (response.data) {
      return response.data;
    } else {
      return {}
    }
  },
  (error) => {
    if (error.status == 403) {
      ElMessage({
        message: error.response.data.detail,
        type: "error",
        duration: 5 * 1000,
      });
      store.dispatch("user/logout");
      return Promise.reject(error.response.data.detail);
    } else if (error.status == 400) {
      let dataInfo = error.response.data;
      let message = "";
      for (const key in dataInfo) {
        message += `${key}:${dataInfo[key].join(",")}`+ "\n";
      }
      ElMessage({
        message: message,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(message);
    } else {
      try {
        let message = "";
        if (error.response.data.error == "invalid_grant") {
          message = "用户名密码错误";
        } else {
          message = error.response.data.error;
        }
        ElMessage({
          message: message,
          type: "error",
          duration: 5 * 1000,
        });
        store.dispatch("user/logout");
        return Promise.reject(message);
      } catch (error) {
        console.log(error)
      }
    }
  }
);

export default service;
